/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
let isTouchDevice = !!("ontouchstart" in window);

const is_touch_enabled = () => {
  try {
    //We try to create touch event. It would fail for desktops and throw an error.
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
};
function is_mobile() {
  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
    isMobile = true;
  } else {
    isMobile = false;
  }
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function (el) {
      const acc_item = item.closest(".accordion__item");
      const panelOuter = acc_item.querySelector(".accordion__answer .inner");
      const panel = acc_item.querySelector(".accordion__answer");
      var openCLass = false;
      if (acc_item.classList.contains("accordion__item--open")) {
        openCLass = true;
      }

      accordionItems.forEach(function (item2) {
        const acc_item2 = item2.closest(".accordion__item");
        acc_item2.querySelector(".accordion__answer").style.maxHeight = null;
        item2.closest(".accordion__item").classList.remove("accordion__item--open");
      });

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panelOuter.scrollHeight + "px";
      }

      if (openCLass) {
        acc_item.classList.remove("accordion__item--open");
        panel.style.maxHeight = null;
        openCLass = false;
      } else {
        acc_item.classList.toggle("accordion__item--open");
      }

      window.addEventListener("resize", function () {
        if (openCLass) {
          const panelOuter = acc_item.querySelector(".accordion__answer .inner");
          panel.style.maxHeight = panelOuter.scrollHeight + "px";
        }
      });
    })
  );
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false, // Disable thumbnails,
    dragToClose: false,
    Panzoom: {
      touch: false
    },
    on: {
      done: (fancybox, slide) => {
        console.log("done");
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones

        // Re-init effects
        const effects = document.querySelectorAll(".effect");

        effects.forEach(function (val) {
          val.classList.add("effect--ready");
        });
      }
    }
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);

  document.querySelectorAll(".siteheader__fancybox-button").forEach(btn => {
    document.querySelectorAll(".fancybox__close").forEach(btn2 => {
      btn2.addEventListener("click", function () {
        Fancybox.close(); // Close Fancybox when any button is clicked
        btn.classList.remove("active");
      });
    });

    btn.addEventListener("click", function () {
      Fancybox.close(); // Close Fancybox when any button is clicked
      btn.classList.remove("active");
    });
  });
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const featuredPeople = document.querySelectorAll(".person__item--active");

const featuredPeopleInit = function (featuredPeople) {
  if (!featuredPeople) {
    return;
  }
  featuredPeople.forEach(item =>
    item.addEventListener("click", function () {
      const acc_item = item.closest(".person__item");
      const panelOuter = acc_item.querySelector(".person__content .person__content__inner");
      const panel = acc_item.querySelector(".person__content");

      var openCLass = false;
      if (item.classList.contains("person__item--open")) {
        openCLass = true;
      }

      featuredPeople.forEach(function (item2) {
        const acc_item2 = item2.closest(".person__item");
        acc_item2.querySelector(".person__content").style.maxHeight = null;
        item2.closest(".person__item").classList.remove("person__item--open");
      });

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panelOuter.scrollHeight + "px";

        window.addEventListener("resize", function () {
          const panelOuter = acc_item.querySelector(".person__content .inner");
          panel.style.maxHeight = panelOuter.scrollHeight + "px";
        });
      }

      if (openCLass) {
        acc_item.classList.remove("person__item--open");
        panel.style.maxHeight = null;
      } else {
        acc_item.classList.toggle("person__item--open");
      }
    })
  );

  window.addEventListener("resize", function () {
    featuredPeople.forEach(function (item) {
      if (item.closest(".person__item").classList.contains("person__item--open")) {
        var panel = item.querySelector(".person__content");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // featuredPeopleInit();
featuredPeopleInit(featuredPeople);

/*  ==========================================================================
    GENERAL - Client Hover
    ========================================================================== */

const featuredClients = document.querySelectorAll(".module--featured-clients");

const featuredClientsInit = function (featuredClients) {
  if (!featuredClients) {
    return;
  }

  if (screen.width >= gridSizes.md) {
    let clients = document.querySelectorAll(".client");

    clients.forEach(client => {
      let hoverImage = client.querySelector(".client__img");
      if (hoverImage) {
        client.addEventListener("mousemove", event => {
          const rect = client.getBoundingClientRect();

          // Calculate mouse position relative to the container
          const mouseX = event.clientX - rect.left;
          const mouseY = event.clientY - rect.top;

          hoverImage.style.opacity = 1;
          hoverImage.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
        });
        client.addEventListener("mouseleave", () => {
          hoverImage.style.opacity = 0;
        });
      }
    });
  }
}; // featuredClientsInit();
featuredClientsInit(featuredClients);

/*  ==========================================================================
    GENERAL - Client Hover
    ========================================================================== */

const postsContainer = document.querySelector(".posts.loadmore-container");

const postsInit = function (postsContainer) {
  if (!postsContainer) {
    return;
  }

  var elem = document.querySelector(".posts");

  var msnry = new Masonry(elem, {
    itemSelector: ".col"
  });
}; // postsInit();

postsInit(postsContainer);

/*  ==========================================================================
    GENERAL - Footer time
    ========================================================================== */

const siteFooterOffices = document.querySelector(".sitefooter__offices");

const siteFooterOfficesInit = function (siteFooterOffices) {
  if (!siteFooterOffices) {
    return;
  }

  let offices = siteFooterOffices.querySelectorAll(".office");

  offices.forEach(office => {
    var officeTime = office.querySelector(".office-time");

    let time = new Date().toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZone: officeTime.dataset.timezone
    });

    officeTime.textContent = time;
  });
}; // siteFooterOfficesInit();

siteFooterOfficesInit(siteFooterOffices);

// Interval to update every second
setInterval(function () {
  siteFooterOfficesInit(siteFooterOffices);
}, 1000);

/*  ==========================================================================
    GENERAL - Project information
    ========================================================================== */

const projectInformation = document.querySelectorAll(".view__projectinformation");

const projectInformationInit = function (projectInformation) {
  if (!projectInformation) {
    return;
  }

  projectInformation.forEach(btn => {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".siteheader__fancybox-button").forEach(btn2 => {
        btn2.classList.add("active");
      });
    });
  });
}; // projectInformationInit();

projectInformationInit(projectInformation);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Custom Cursor
    ========================================================================== */

var cursor = {
  delay: 8,
  _x: 0,
  _y: 0,
  endX: window.innerWidth / 2,
  endY: window.innerHeight / 2,
  cursorVisible: true,
  cursorEnlarged: false,
  $dot: document.querySelector(".cursor-dot"),

  init: function () {
    // Set up element sizes
    this.dotSize = this.$dot.offsetWidth;
    this.setupEventListeners();
    this.animateDot();
  },

  setupEventListeners: function () {
    var self = this;

    document.addEventListener("mousemove", function (e) {
      // Show the cursor
      self.cursorVisible = true;
      self.toggleCursorVisibility();

      // Position the dot
      self.endX = e.clientX;
      self.endY = e.clientY;
      self.$dot.style.top = self.endY + "px";
      self.$dot.style.left = self.endX + "px";
    });

    // Hide/show cursor
    document.addEventListener("mouseenter", function (e) {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 1;
    });

    document.addEventListener("mouseleave", function (e) {
      self.cursorVisible = true;
      self.toggleCursorVisibility();
      self.$dot.style.opacity = 0;
    });
  },

  animateDot: function () {
    var self = this;

    self._x += (self.endX - self._x) / self.delay;
    self._y += (self.endY - self._y) / self.delay;
    self.$dot.style.top = self._y + "px";
    self.$dot.style.left = self._x + "px";

    requestAnimationFrame(this.animateDot.bind(self));
  },

  toggleCursorSize: function () {
    var self = this;
    if (self.cursorEnlarged) {
      self.$dot.style.transform = "translate(-50%, -50%) scale(2)";
    } else {
      self.$dot.style.transform = "translate(-50%, -50%) scale(1)";
    }
  },

  toggleCursorBtn: function () {
    var self = this;
    if (self.cursorEnlarged) {
      self.$dot.style.transform = "translate(-50%, -50%) scale(3)";
    } else {
      self.$dot.style.transform = "translate(-50%, -50%) scale(1)";
    }
  },

  toggleCursorVisibility: function () {
    var self = this;
    if (self.cursorVisible) {
      self.$dot.style.opacity = 1;
    } else {
      self.$dot.style.opacity = 0;
    }
  }
};

// if not, just load cursor if not mobile
if (!isMobile && !is_touch_enabled()) {
  cursor.init();
}

/*  ==========================================================================
    GENERAL - Background changer
    ========================================================================== */

const backgroundChangerInit = function () {
  const backgroundChanger = document.querySelectorAll(".background__changer-line");

  if (!backgroundChanger) {
    return;
  }

  // Initialize Waypoints for each section
  backgroundChanger.forEach(bgChanger => {
    const bgColor = bgChanger.getAttribute("data-bg-color");

    // Scroll down - Change the background color
    new Waypoint({
      element: bgChanger,
      handler: function (direction) {
        let bgColour = bgChanger.dataset.bgcolor ? bgChanger.dataset.bgcolor : false;
        let textColour = bgChanger.dataset.textcolor ? bgChanger.dataset.textcolor : false;

        let navBgColor = bgChanger.dataset.bgcolor ? bgChanger.dataset.navbgcolor : false;
        let navTextColor = bgChanger.dataset.textcolor ? bgChanger.dataset.navtextcolor : false;

        if (direction === "down") {
          document.documentElement.style.setProperty("--bg-color", bgColour);
          document.documentElement.style.setProperty("--page-bg", bgColour);
          document.documentElement.style.setProperty("--page-color", textColour);
          document.documentElement.style.setProperty("--font-color", textColour);
          document.documentElement.style.setProperty("--hover-color", bgColour);

          document.documentElement.style.setProperty("--nav-text-color", navBgColor);
          document.documentElement.style.setProperty("--nav-bg-color", navTextColor);
        }
      },
      offset: "50%" // Trigger when the section is halfway in view
    });

    // Scroll up - Reset to the previous background color
    new Waypoint({
      element: bgChanger,
      handler: function (direction) {
        let bgColour = bgChanger.dataset.bgcolor ? bgChanger.dataset.bgcolor : false;
        let textColour = bgChanger.dataset.textcolor ? bgChanger.dataset.textcolor : false;

        let navBgColor = bgChanger.dataset.bgcolor ? bgChanger.dataset.navbgcolor : false;
        let navTextColor = bgChanger.dataset.textcolor ? bgChanger.dataset.navtextcolor : false;

        if (direction === "up") {
          document.documentElement.style.setProperty("--bg-color", bgColour);
          document.documentElement.style.setProperty("--page-bg", bgColour);
          document.documentElement.style.setProperty("--page-color", textColour);
          document.documentElement.style.setProperty("--font-color", textColour);
          document.documentElement.style.setProperty("--hover-color", bgColour);

          document.documentElement.style.setProperty("--nav-text-color", navBgColor);
          document.documentElement.style.setProperty("--nav-bg-color", navTextColor);
        }
      },
      offset: "-50%" // Trigger when leaving the section upward
    });
  });
}; // backgroundChangerInit();
backgroundChangerInit();

/*  ==========================================================================
		Check Scroll
		========================================================================== */
let oldScrollY = 0;

const checkScrollInit = function () {
  const siteheader = document.querySelector(".siteheader");

  if (!siteheader) {
    return;
  }

  if ($(window).scrollTop() > 0) {
    siteheader.classList.add("siteheader--scrolled");
  } else {
    siteheader.classList.remove("siteheader--scrolled");
  }
};

window.onscroll = function () {
  checkScrollInit();
};

checkScrollInit();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggleLinks = document.querySelectorAll(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggleLinks.forEach(function (mobnavToggle) {
    mobnavToggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (!body.classList.contains(mobnavOpenclass)) {
        // IT'S NOT OPEN...
        body.classList.add(mobnavOpenclass);
      } else {
        // IT'S OPEN...
        body.classList.remove(mobnavOpenclass);
      }
    });
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth >= gridSizes.lg) {
      if (body.classList.contains(mobnavOpenclass)) {
        // IT'S OPEN...
        body.classList.remove(mobnavOpenclass);
      }
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// // Search open & close
// const searchNav = document.querySelector(".siteheader__search");
// const searchToggle = document.querySelector(".search-toggle");
// const searchInput = document.querySelector(".siteheader__search .searchform__input input");

// // Close search modal when clicked elsewhere in the document
// const clickedOusideSearch = function (e) {
//   if (!searchNav.classList.contains("siteheader__search--open")) {
//     return;
//   }

//   var isClickInsideElement =
//     searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

//   if (!isClickInsideElement) {
//     searchNav.classList.remove("siteheader__search--open");
//     body.removeEventListener("mouseup", clickedOusideSearch, false);
//   }
// }; // clickedOusideSearch();

// // Toggle search modal window
// const searchModalToggle = function (e) {
//   e.preventDefault();
//   if (searchNav.classList.contains("siteheader__search--open")) {
//     searchNav.classList.remove("siteheader__search--open");
//     body.removeEventListener("mouseup", clickedOusideSearch, false);
//   } else {
//     searchNav.classList.add("siteheader__search--open");
//     searchInput.focus();
//     body.addEventListener("mouseup", clickedOusideSearch, false);
//   }
// }; // searchModalToggle();

// const searchModalInit = function () {
//   if (!searchNav) {
//     return;
//   }
//   searchToggle.addEventListener("click", searchModalToggle);
// }; // searchModalInit();

// searchModalInit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();
